import { CodeArticleVersion } from '@livv/models';
import { FC } from 'react';
import Version from './Version';
import Timeline from '@components/Timeline';

const LAST_MAX_TIMESTAMP = 60 * 60 * 24 * 365 * 10 + Date.now() / 1000; // limit to 10 years in the future

interface VersionsTimelineProps {
    comparisonMode: boolean;
    setVersionsSelected: (versionsSelected: CodeArticleVersion[]) => void;
    versions: CodeArticleVersion[];
    versionsSelected: CodeArticleVersion[];
}

export type CodeArticleVersionWithPosition = CodeArticleVersion & { leftPosition: number };

const VersionsTimeline: FC<VersionsTimelineProps> = ({
    comparisonMode,
    setVersionsSelected,
    versions,
    versionsSelected,
}) => (
    <Timeline
        timelineEntries={versions.map((version) => ({
            content: (
                <Version
                    key={version.legifranceId}
                    comparisonMode={comparisonMode}
                    setVersionsSelected={setVersionsSelected}
                    version={version}
                    versionsSelected={versionsSelected}
                />
            ),
            id: version.legifranceId,
            timestamp: Math.min(version.dateDebut.seconds, LAST_MAX_TIMESTAMP), // Limit last timestamp to 10 years in the future
        }))}
    />
);

export default VersionsTimeline;
